"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Crop Images',
  description: "When true, the consumer will have the option to either crop the items to fill their containers or to fit\n  them inside (the \"FIT\" option may leave empty margins around the items).",
  isRelevant: function isRelevant() {
    return true;
  },
  type: _constants.INPUT_TYPES.BOOLEAN,
  "default": false
};
exports["default"] = _default;